// ----------------------------------------------------------------------

export default function Breadcrumbs(theme) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: theme.spacing(0.5),
          marginRight: theme.spacing(0.5),
        },
      },
    },
  };
}
